const UrlsData = {
  soulsDefender: 'https://souldefender.com.au', // available / limited / not
}

export default UrlsData
